import React from "react";
import { useLocation  } from "react-router-dom";
import { Link } from "react-router-dom";
import "../css/footer.css";


export default function Footer(){
    return(
        <footer>
            <Link to="/mobile_app">
                <div className="footer-content">Mobilní aplikace Terminálu</div>
            </Link>
            {/* <div className="footer-content">Ochrana osobních údajů</div> */}
            <div className="footer-content"><a href="https://peersight.carrd.co/">O nás</a></div>
            <div className="footer-content">© 2024 Jakub Matoušek</div>
        </footer>
    )
}